import { css } from '@emotion/core';
import { aTag, tokens, applyFont } from '@domain-group/fe-brary';
var colors = tokens.colors,
  typography = tokens.typography;
var separatorColour = colors.neutral.trim.default;
export var separator = /*#__PURE__*/css("border-bottom:1px solid ", separatorColour, ";");
export var separatorLink = /*#__PURE__*/css(aTag, ";border-bottom:1px solid ", separatorColour, ";border-top:1px solid ", separatorColour, ";padding:13px 0;display:flex;");
export var icon = {
  name: "13l12b",
  styles: "margin-right:12px;width:22px;height:22px;"
};
export var linkText = /*#__PURE__*/css(applyFont(typography.bodyBold), ";display:block;line-height:16px;padding-top:2px;height:22px;");